import { ApiError } from "@/lib/api/api-error";

export const SESSION_ACCESS_REFRESH_MS = 30_000;

interface QueryWithErrorState {
  state: {
    error: unknown;
  };
}

export type SessionErrorState = {
  kind: "forbidden" | "missing" | "unavailable";
  title: string;
  description: string;
  canRetry: boolean;
};

export function isTerminalSessionError(error: unknown) {
  return (
    error instanceof ApiError && (error.status === 403 || error.status === 404)
  );
}

export function getSessionAccessRefetchInterval(query: QueryWithErrorState) {
  return isTerminalSessionError(query.state.error)
    ? false
    : SESSION_ACCESS_REFRESH_MS;
}

export function getSessionErrorState(error: unknown): SessionErrorState {
  if (error instanceof ApiError && error.status === 403) {
    return {
      kind: "forbidden",
      title: "Access revoked",
      description:
        "Your supplier no longer has access to this agent or session.",
      canRetry: false,
    };
  }

  if (error instanceof ApiError && error.status === 404) {
    return {
      kind: "missing",
      title: "Session not found",
      description: "This session no longer exists or has expired.",
      canRetry: false,
    };
  }

  return {
    kind: "unavailable",
    title: "Session unavailable",
    description: "The session could not be loaded. Please try again shortly.",
    canRetry: true,
  };
}
